const SERVICE_TYPES = {
  alignment: {
    asset: 'icon-alignment',
    alternative: 'alignment-red'
  },
  batteries: {
    asset: 'icon-battery',
    alternative: 'battery-red'
  },
  brakes: {
    asset: 'icon-brakes',
    alternative: 'brakes-red'
  },
  'oil-lube-and-filter': {
    asset: 'icon-oil',
    alternative: 'oil-red'
  },
  'routine-services-and-fluids': {
    asset: 'icon-routine',
    alternative: 'routine-red'
  },
  'suspension-and-front-end': {
    asset: 'icon-suspension',
    alternative: 'suspension-red'
  },
  'tire-service-and-repair': {
    asset: 'icon-repair',
    alternative: 'repair-red'
  },
  'air-filter-change': {
    asset: 'air-filter-change',
    alternative: 'air-filter-change-red'
  },
  'alternator-stering-and-replacement': {
    asset: 'alternator-stering-and-replacement',
    alternative: 'alternator-stering-and-replacement-red'
  },
  'ball-joints': {
    asset: 'ball-joints',
    alternative: 'ball-joints-red'
  },
  'battery-cable-replacement': {
    asset: 'battery-cable-replacement',
    alternative: 'battery-cable-replacement-red'
  },
  'battery-testing': {
    asset: 'battery-testing',
    alternative: 'battery-testing-red'
  },
  'belt-replacement': {
    asset: 'belt-replacement',
    alternative: 'belt-replacement-red'
  },
  'brake-fluid-exchange': {
    asset: 'brake-fluid-exchange',
    alternative: 'brake-fluid-exchange-red'
  },
  'brake-inspection': {
    asset: 'brake-inspection',
    alternative: 'brake-inspection-red'
  },
  'brake-repair': {
    asset: 'brake-repair',
    alternative: 'brake-repair-red'
  },
  'cv-joints-and-cv-axles': {
    asset: 'cv-joints-and-cv-axles',
    alternative: 'cv-joints-and-cv-axles-red'
  },
  'cabin-filter-change': {
    asset: 'cabin-filter-change',
    alternative: 'cabin-filter-change-red'
  },
  'cooling-stering-flush-and-fill': {
    asset: 'cooling-stering-flush-and-fill',
    alternative: 'cooling-stering-flush-and-fill-red'
  },
  'differential-fluid-exchange': {
    asset: 'differential-fluid-exchange',
    alternative: 'differential-fluid-exchange-red'
  },
  'fuel-filter-change': {
    asset: 'fuel-filter-change',
    alternative: 'fuel-filter-change-red'
  },
  'fuel-system-cleaning': {
    asset: 'fuel-system-cleaning',
    alternative: 'fuel-system-cleaning-red'
  },
  'headlights-and-taillights': {
    asset: 'headlights-and-taillights',
    alternative: 'headlights-and-taillights-red'
  },
  'install-interstate-battery': {
    asset: 'install-interstate-battery',
    alternative: 'install-interstate-battery-red'
  },
  'install-interstate-mega-tron-ii-battery': {
    asset: 'install-interstate-mega-tron-ii-battery',
    alternative: 'install-interstate-mega-tron-ii-battery-red'
  },
  'install-interstate-powerfast-battery': {
    asset: 'install-interstate-powerfast-battery',
    alternative: 'install-interstate-powerfast-battery-red'
  },
  'oil-change': {
    asset: 'oil-change',
    alternative: 'oil-change-red'
  },
  'oil-services': {
    asset: 'oil-change',
    alternative: 'oil-change-red'
  },
  'power-stering-fluid-exchange': {
    asset: 'power-stering-fluid-exchange',
    alternative: 'power-stering-fluid-exchange-red'
  },
  'rack-and-pinion': {
    asset: 'rack-and-pinion',
    alternative: 'rack-and-pinion-red'
  },
  'radiant-and-coolant-hoses': {
    asset: 'radiant-and-coolant-hoses',
    alternative: 'radiant-and-coolant-hoses-red'
  },
  'shocks-shocks': {
    asset: 'shocks-shocks',
    alternative: 'shocks-shocks-red'
  },
  'snow-tire-installation': {
    asset: 'snow-tire-installation',
    alternative: 'snow-tire-installation-red'
  },
  'starter-stering-and-replacement': {
    asset: 'starter-stering-and-replacement',
    alternative: 'starter-stering-and-replacement-red'
  },
  'steering-stering-suspension-evaluation': {
    asset: 'steering-stering-suspension-evaluation',
    alternative: 'steering-stering-suspension-evaluation-red'
  },
  'struts-struts': {
    asset: 'struts-struts',
    alternative: 'struts-struts-red'
  },
  'tie-rods': {
    asset: 'tie-rods',
    alternative: 'tie-rods-red'
  },
  'tire-mounting': {
    asset: 'tire-mounting',
    alternative: 'tire-mounting-red'
  },
  'tire-pressure-check': {
    asset: 'tire-pressure-check',
    alternative: 'tire-pressure-check-red'
  },
  'tire-repair': {
    asset: 'tire-repair',
    alternative: 'tire-repair-red'
  },
  'tire-services': {
    asset: 'icon-repair',
    alternative: 'repair-red'
  },
  'tire-rotation': {
    asset: 'tire-rotation',
    alternative: 'tire-rotation-red'
  },
  'transmission-fluid-exchange': {
    asset: 'transmission-fluid-exchange',
    alternative: 'transmission-fluid-exchange-red'
  },
  'used-tires': {
    asset: 'used-tires',
    alternative: 'used-tires-red'
  },
  'wheel-alignment': {
    asset: 'wheel-alignment',
    alternative: 'wheel-alignment-red'
  },
  'wheel-balancing': {
    asset: 'wheel-balancing',
    alternative: 'wheel-balancing-red'
  },
  'wiper-blades': {
    asset: 'wiper-blades',
    alternative: 'wiper-blades-red'
  }
}

export default SERVICE_TYPES
